import 'generated/resources/graphql'
import {
  GeneratePreviewDocument,
  GeneratePreviewMutation,
  GeneratePreviewMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useGeneratePreviewDocument = () => {
  const [generatePreviewMutation, { loading }] = useMutation(GeneratePreviewDocument, {
    extractorFn: (data: GeneratePreviewMutation) =>
      data.documentsMutations.generatePreviewDocumentsDocument,
  })

  return {
    loading,
    generatePreview(variables: GeneratePreviewMutationVariables) {
      return generatePreviewMutation({
        variables,
      })
    },
  }
}

export default useGeneratePreviewDocument
